import "../../../../content/projects/saf/saf.css";
import * as React from 'react';
export default {
  React
};